// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.select-dashboard-dialog-container {
  height: 100%;
  display: flex;
  flex-flow: column;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/job/components/dashboard/dialogs/select-dashboard-dialog/select-dashboard-dialog.component.scss"],"names":[],"mappings":"AAAA;EACC,YAAA;EACA,aAAA;EACA,iBAAA;AACD","sourcesContent":[".select-dashboard-dialog-container {\n\theight: 100%;\n\tdisplay: flex;\n\tflex-flow: column;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
